import { h, Component } from "preact";
import { css } from "emotion";

const styles = {
  item: css`
    width: 140px;
    height: 80px;
    margin-left: 12px;
    margin-right: 12px;
    @media (max-width: 600px) {
      width: 100px;
      height: 57px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  `
};

/**
 * Display sponsor logos
 *
 * @param {*} { sponsorsLogos, sponsorBoxBackgroundColor }
 * @returns
 */
const Sponsors = ({ sponsorsLogos, sponsorBoxBackgroundColor }) => {
  const customStyles = {
    wrapper: css`
      min-height: 120px;
      width: 100%;
      display: flex;
      padding-top: 40px;
      padding-bottom: 40px;
      justify-content: center;
      flex-wrap: wrap;
      background-color: ${sponsorBoxBackgroundColor};
      margin-top: 72px;
      @media (max-width: 600px) {
        padding-top: 30px;
        padding-bottom: 30px;
        margin-top: 40px;
      }
    `
  };
  if (!sponsorsLogos || !sponsorsLogos.length) {
    return <div style={{ width: "100%", height: 72 }} />;
  }
  return (
    <div className={customStyles.wrapper}>
      {sponsorsLogos.map(sponsor => {
        return <img src={sponsor.url} className={styles.item} />;
      })}
    </div>
  );
};

export default Sponsors;



// WEBPACK FOOTER //
// ./routes/tours/Sponsors.js